import cx from 'classnames';

import Render from 'components/render';
import useWalletIndianExchange from 'hooks/componentHooks/useWalletIndianExchange';
import i18n from 'i18n/config';
import { AngleDown, AngleUp } from 'styles/assets/icons';
import Box from 'UIKit/Box';
import CollapsibleCard from 'UIKit/CollapsibleCard';
import DeltaButton from 'UIKit/DeltaButton';

import { TotalEquity } from '../computeTotalBalance';
import BlockedMargin from './BlockedMargin';
import styles from './indianWallet.module.scss';
import TooltipWrapper from './TooltipWrapper';
import UnRealisedCashflow from './UnRealisedCashflow';

const headerAccountValue = i18n.t('headerFooter:header.wallet.tradingWallet');
const headerAccountBalance = i18n.t('headerFooter:header.wallet.walletBalance');
const accountBalancePopOverIndianExchange = i18n.t(
  'headerFooter:header.wallet.accountBalancePopOverIndianExchange'
);

const AccountValueCollapsableCard = ({ showAmount = true }: { showAmount: boolean }) => {
  const { accountBalance } = useWalletIndianExchange();

  return (
    <CollapsibleCard expandedHeight="fit-content">
      {(toggleCollapsed, isCollapsed) => (
        <>
          <DeltaButton
            data-testid="account-balance-btn"
            fullWidth
            useBasicButton
            transparentBg
            onClick={toggleCollapsed}
            className={cx(
              'naked flex-set pointer',
              styles['label-value-container'],
              styles.accountValueCollapsableButton
            )}
            wrapperClassName="flex-set flex--content-center flex--align-items-start flex--content-between flex--full-width-item"
          >
            <Box>
              {headerAccountValue}
              <span
                data-testid="collapse-contract-type-filter"
                className={cx(styles.collapseIcons, {
                  [styles.collapsedIcon]: isCollapsed,
                  [styles.expandedIcon]: !isCollapsed,
                })}
              >
                {isCollapsed ? <AngleDown /> : <AngleUp />}
              </span>
            </Box>
            <Box className={styles.value}>
              <Box className={styles.inr}>
                <Render when={showAmount} else="******">
                  <TotalEquity isInr isForWalletIndianExchange />
                </Render>
              </Box>
              <Box className={styles.usd}>
                <Render when={showAmount} else="******">
                  <TotalEquity isForWalletIndianExchange />
                </Render>
              </Box>
            </Box>
          </DeltaButton>

          <Box renderWhen={!isCollapsed} className="pl-2">
            {/* Account Balance */}
            <Box renderWhen={!isCollapsed} className={styles['label-value-container']}>
              <Box className={styles.label}>
                <TooltipWrapper
                  title={headerAccountBalance}
                  body={accountBalancePopOverIndianExchange}
                />
              </Box>
              <Box className={styles.value}>
                <Box className={styles.inr}>
                  <Render when={showAmount} else="******">
                    {accountBalance.accountBalanceFormattedInINR}
                  </Render>
                </Box>
                <Box className={styles.usd}>
                  <Render when={showAmount} else="******">
                    {accountBalance.accountBalanceFormattedInUSD}
                  </Render>
                </Box>
              </Box>
            </Box>

            {/* UNREALIZED CASHFLOW */}
            <UnRealisedCashflow showAmount={showAmount} />

            {/* Blocked Margin */}
            <BlockedMargin showAmount={showAmount} />
          </Box>
        </>
      )}
    </CollapsibleCard>
  );
};

export default AccountValueCollapsableCard;
